module.exports = __webpack_public_path__ + "img/mobile_success_banner.8c0d0f3b.png";